import React, { ReactNode, useRef, useEffect } from 'react';
import { useLocation } from '@tanstack/react-router';
import { ErrorBoundary as ErrorBoundaryClass } from './ErrorBoundary';

export const ErrorBoundaryWithLocation = ({ children, fallback }: { children: ReactNode; fallback?: ReactNode }) => {
  const loc = useLocation();
  const classRef = useRef<ErrorBoundaryClass>(null);

  useEffect(() => {
    const instance = classRef.current;
    if (instance) {
      instance.clearError();
    }
  }, [loc.pathname]);

  return (
    <ErrorBoundaryClass ref={classRef} fallback={fallback}>
      {children}
    </ErrorBoundaryClass>
  );
};
